<form [formGroup]="formGroup">
  <mat-dialog-content>
    <div class="delegation-form">
      <div class="row">
        <div class="col">
          <h2>{{ 'DF-AddDelegation' | translate }}</h2>
        </div>
        @if (!!statusName.value) {
        <div class="delegation-status">
          <mat-card appearance="outlined">{{ statusName.value }}</mat-card>
        </div>
        }
      </div>
      <div class="row">
        <div class="col">
          <h3>{{ 'DF-EmployeeData' | translate }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-label>{{ 'DF-FullName' | translate }}</mat-label>
          {{ fullNameSubject | async }}
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-Agreement' | translate }}</mat-label>
            <mat-select formControlName="activeAgreement">
              @for (agreement of agreements$ | async; track agreement) {
              <mat-option #matOption [value]="agreement"
                >{{ agreement.EmployerName }} {{ agreement.EmploymentDateFrom | date : 'yyyy-MM-dd' }} -
                {{ agreement.EmploymentDateTo | date : 'yyyy-MM-dd' }}</mat-option
              >
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-Company' | translate }}</mat-label>
            <input matInput disabled="true" [value]="activeAgreement?.Company" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-Employer' | translate }}</mat-label>
            <input matInput disabled="true" [value]="activeAgreement?.Employer" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-Client' | translate }}</mat-label>
            <input matInput disabled="true" [value]="activeAgreement?.Client" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-OrganizationalUnit' | translate }}</mat-label>
            <input matInput disabled="true" [value]="activeAgreement?.OrganizationalUnit" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <h2>{{ 'DF-BusinessTrip' | translate }}</h2>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-DestinationCountry' | translate }}</mat-label>
            <mat-select formControlName="country">
              @for (country of listOfCountries$ | async; track country) {
              <mat-option [value]="country.Id"> {{ country.Name }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-DestinationCity' | translate }}</mat-label>
            <input
              matInput
              formControlName="destinationCity"
              placeholder="{{ 'DF-DestinationCity' | translate }}"
              [matAutocomplete]="autocompleteCity"
            />
            <mat-autocomplete #autocompleteCity="matAutocomplete">
              @for (city of listOfCities$ | async; track city) {
              <mat-option [value]="city">
                {{ city }}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'StartDate' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              formControlName="startDate"
              [matDatepickerFilter]="startDateFilter"
              placeholder="{{ 'StartDate' | translate }}"
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col col-lg-3">
          <ngx-timepicker-field
            formControlName="startTime"
            [format]="timepickerTimeFormat"
            [cancelBtnTmpl]="customCancelButton"
            [confirmBtnTmpl]="customConfirmButton"
          ></ngx-timepicker-field>
        </div>
      </div>
      <div class="row">
        <div class="col col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'EndDate' | translate }}</mat-label>
            <input
              matInput
              [matDatepicker]="endDatePicker"
              [matDatepickerFilter]="endDateFilter"
              formControlName="endDate"
              placeholder="{{ 'EndDate' | translate }}"
            />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col col-lg-3">
          <ngx-timepicker-field
            formControlName="endTime"
            [format]="timepickerTimeFormat"
            [cancelBtnTmpl]="customCancelButton"
            [confirmBtnTmpl]="customConfirmButton"
          ></ngx-timepicker-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-DelegationPurpose' | translate }}</mat-label>
            <mat-select formControlName="delegationPurpose">
              @for (delegationPurpose of delegationPurposes$ | async; track delegationPurpose) {
              <mat-option [value]="delegationPurpose.Id">
                {{ delegationPurpose.Name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (shouldShowForEmployerObjectControl) {
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-ForEmployerObject' | translate }}</mat-label>
            <mat-select formControlName="forEmployerObject">
              @for (employerObject of accesedEmployerObjects$ | async; track employerObject) {
              <mat-option [value]="employerObject">
                {{ employerObject.Name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DF-TransportType' | translate }}</mat-label>
            <mat-select formControlName="transportType">
              @for (transportType of transportTypes$ | async; track transportType) {
              <mat-option [value]="transportType.Id"> {{ transportType.Name }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (activeAgreement?.IsDelegationAdvancePaymentEnabled) {
      @if (hasAdvancePayment) {
      <div class="row">
        <div class="col">
          <div class="advance-payments-wrapper">
            <div class="row" formGroupName="advancePayment">
              <div class="col-4">
                <mat-form-field fxFill appearance="outline">
                  <mat-label>{{ 'DF-AdvancePayment' | translate }}</mat-label>
                  <input matInput numericOnlyWtihTwoDecimals type="text" class="text-center" formControlName="value" min="0" required />
                </mat-form-field>
              </div>
              <div class="col-2">
                <mat-form-field fxFill appearance="outline">
                  <mat-label>{{ 'Currency' | translate }}</mat-label>
                  <mat-select formControlName="currencyId">
                    @for (currency of listOfCurrencies$ | async; track currency) {
                    <mat-option [value]="currency.Id">
                      {{ currency.Name }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-1">
                <button
                  id="delegation-form-delete-advance-payment-button"
                  mat-icon-button
                  color="primary"
                  class="trash-button"
                  (click)="deleteAdvancePayment()"
                  [disabled]="!isAdvancePaymentButtonVisible()"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      @if (isAdvancePaymentButtonVisible()) {
      <div class="row">
        <div class="col">
          <button
            id="delegation-form-add-advance-payment-button"
            mat-raised-button
            color="primary"
            class="mr-1 float-right"
            type="button"
            (click)="addNewAdvancePayment()"
            [disabled]="hasAdvancePayment"
          >
            <mat-icon>add_box</mat-icon>
            <span>{{ 'AF-AddAdvancePayment' | translate }}</span>
          </button>
        </div>
      </div>
      } }
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="row">
    <div class="col-6">
      <button mat-raised-button id="delegation-form-close-button" class="mr-1 float-left" color="basic" (click)="close()">
        {{ 'Close' | translate }}
      </button>
    </div>
    @if (isSaveAsDraftButtonVisible()) {
    <div class="col-3">
      <button mat-raised-button id="delegation-form-save-button" class="mr-1 float-right" color="primary" (click)="saveAsDraft()">
        {{ 'DF-SaveAsDraft' | translate }}
      </button>
    </div>
    } @if (isSendButtonVisible()) {
    <div class="col-3">
      <button mat-raised-button id="delegation-form-send-to-approval-button" class="mr-1 float-right" color="primary" (click)="sendToApprovalClicked()">
        {{ 'DF-SendToApproval' | translate }}
      </button>
    </div>
    } 
    @if (isDelegationActionButtonVisible()) {
      <div class="col-6 button-container">
        <button
          id="delegation-form-accept-button"
          class="float-right"
          *ifHasPermissions="['ManageWorkerDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
          mat-raised-button
          color="success"
          (click)="acceptDelegation()"
        >
          {{ 'Accept' | translate }}
        </button>
        <button
          id="delegation-form-reject-button"
          mat-raised-button
          *ifHasPermissions="['ManageWorkerDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
          color="error"
          (click)="rejectDelegation()"
        >
          {{ 'Reject' | translate }}
        </button>
      </div>
    }
  </div>
</form>

<ng-template #customCancelButton>
  <button mat-button>
    {{ 'Cancel' | translate }}
  </button>
</ng-template>

<ng-template #customConfirmButton>
  <button mat-button>
    {{ 'Yes' | translate }}
  </button>
</ng-template>
